import {Avatar, Checkbox, Input, Radio} from 'antd'
import {poll_addAnswer_Api, poll_getVoters_Api,} from 'apis'
import {userModel} from 'apis/model'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import {useRequiredLogin} from '../../views/Server/useRequiredLogin'
import Modal from '../Modal/Modal'
import Toggle from '../Toggle'
import {FollowButton} from './FollowButton'
import {RiAddCircleLine, RiCheckLine, RiCloseLine, RiUserFill} from "react-icons/ri"
import TooltipApp from "components/TooltipApp"
import {showConfirmDialog} from "../../views/AppLocals/factory/createConfirmDialog";
import {PiHandPointing} from "react-icons/pi";
import {notifyOnError} from "../../views/AppLocals/factory/createErrorEvent";
import {poll_unVoteOnPoll_Api, poll_vote_Api} from "../../apis";

const renderItem = (item, i) => {
    if (!item) return null
    return (
        <Translate>
            {(t) => (
                <div key={i} className="py-2 px-4 flex w-full border-b border-gray-300">
                    <div style={{flexShrink: 0}} className="flex">
                        <Avatar
                            size="large"
                            style={{background: '#f1f1f1', marginRight: '1em'}}
                            src={item.avatar}
                            shape={item._type === 'user' ? 'circle' : 'square'}>
                            {getTitle(item)}
                        </Avatar>
                    </div>
                    <div className="flex-1 overflow-hidden">
                        <div className="flex items-start">
                            <div className="flex-1 overflow-hidden">
                                <Link
                                    to={getLinkToDetail(item)}
                                    className="cursor-pointer font-bold leading-tight truncate">
                                    {item.title || item.name}
                                </Link>
                                <div className="text-xs text-color-300 leading-tight truncate">
                                    <span>{item.idname || item.username}</span>
                                </div>
                            </div>
                        </div>
                        <div className="text-xs">{item.description || item.about}</div>
                    </div>
                    <div>
                        <FollowButton/>
                    </div>
                </div>
            )}
        </Translate>
    )
}

// ─── Voters mini-list (dùng chung cho cả poll và quiz) ───────────────────────
const VoterAvatars = ({voters, restNumber, id, poll_answer_id}) => {
    const t = useTranslate()
    if (!voters.length) return null
    return (
        <div className="flex items-center gap-1">
            {voters.map(
                (item, i) =>
                    i < 3 && (
                        <TooltipApp key={i} title={userModel.getTitle(item)}>
                            <Avatar
                                size={20}
                                className="background-100 border border-color-50 flex flex-center"
                                icon={<RiUserFill size={10} className="text-color-500"/>}
                                src={userModel.getThumbnailUrl(item)}
                            />
                        </TooltipApp>
                    )
            )}
            {restNumber > 0 && (
                <Toggle>
                    {(isToggle, toggle) => (
                        <>
                            <Avatar
                                size="small"
                                className="background-100 border border-color-50 flex flex-center">
                                +{restNumber}
                            </Avatar>
                            <Modal
                                maskClosable
                                onCancel={toggle}
                                open={isToggle}
                                title={t('users')}>
                                <LazyPagination
                                    apiInfo={poll_getVoters_Api}
                                    query={{
                                        ':poll_question_id': id,
                                        ':poll_answer_id': poll_answer_id,
                                    }}
                                    renderItem={renderItem}
                                />
                            </Modal>
                        </>
                    )}
                </Toggle>
            )}
        </div>
    )
}

export function PollEmbed({poll: _poll}) {
    const [poll, setPollItem] = useState(_poll)
    const {
        id,
        title: question = 'What framework do you prefer?',
        total_votes,
        is_yesno_question = 1,
        poll_answers = [],
        poll_yesno_answers = [],
        poll_type,
        vote_status,
    } = poll || {}

    const getPercent = (voteNumber) =>
        total_votes ? Math.floor((voteNumber * 100) / total_votes) : 0

    const [newAnswer, setNewAnswer] = useState('')
    const {
        isLoading,
        handleAsyncAction: addNewAnswer,
    } = useAsyncAction({
        onSuccess: () => setNewAnswer(''),
        apiInfo: poll_addAnswer_Api,
        query: {':poll_question_id': id},
    })

    const requireLogin = useRequiredLogin()
    const isQuiz = poll_type === "quiz"
    const hasAnswered = Boolean(vote_status)
    const t = useTranslate()

    const {handleAsyncAction: pollVote} = useAsyncAction({
        apiInfo: poll_vote_Api,
        onError: notifyOnError(t),
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setPollItem(dataItem)
        },
    });
    const {handleAsyncAction: pollUnVote} = useAsyncAction({
        apiInfo: poll_unVoteOnPoll_Api,
        onError: notifyOnError(t),
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setPollItem(dataItem)
        },
    });
    const handleVote = (poll_answer_id, answer_vote_status) => {
        if (!answer_vote_status) {
            requireLogin(() => pollVote({}, {
                poll_question_id: id,
                poll_answer_id
            }))
        } else {
            requireLogin(() => pollUnVote({}, {
                poll_question_id: id,
                poll_answer_id
            }))
        }
    }

    const input = (
        <Input.Search
            onChange={(e) => setNewAnswer(e.target.value)}
            loading={isLoading}
            className="w-full input-search-article-linking"
            placeholder={t('new answer')}
            enterButton={<span className="text-sm font-medium">{t('add')}</span>}
            value={newAnswer}
            onSearch={(value) => addNewAnswer({title: value})}
        />
    )

    // ─── QUIZ mode: kết quả sau khi trả lời ──────────────────────────────────
    const renderQuizAnswers = (answers) =>
        answers.map(({title, vote_status: answer_vote_status, id: poll_answer_id, is_correct}, i) => {
            const isCorrectAnswer = Boolean(is_correct)
            const isMyAnswer = Boolean(answer_vote_status)

            const rowStyle = isMyAnswer
                ? isCorrectAnswer
                    ? {background: 'rgba(34,197,94,0.10)', border: '1px solid #22c55e'}
                    : {background: 'rgba(249,115,22,0.10)', border: '1px solid #f97316'}
                : isCorrectAnswer
                    ? {background: 'rgba(34,197,94,0.06)', border: '1px solid rgba(34,197,94,0.30)'}
                    : {background: 'var(--background-100)', border: '1px solid var(--border-color-100)'}

            return (
                <div
                    key={i}
                    style={{
                        ...rowStyle,
                        borderRadius: 8,
                        padding: '9px 12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        transition: 'background 0.2s',
                    }}>

                    {/* Indicator */}
                    <div style={{
                        width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: isCorrectAnswer ? '#22c55e' : 'var(--background-100)',
                        border: isCorrectAnswer ? 'none' : '1px solid var(--border-color-base)',
                    }}>
                        {isCorrectAnswer && <RiCheckLine size={12} color="#fff"/>}
                    </div>

                    {/* Label */}
                    <span style={{
                        flex: 1, fontSize: 13, lineHeight: 1.5,
                        fontWeight: isCorrectAnswer ? 500 : 400,
                        color: isCorrectAnswer ? 'var(--text-color)' : 'var(--text-color-100)',
                    }}>
                        {title}
                    </span>

                    {/* Badge đúng/sai */}
                    {isMyAnswer && (
                        <span style={{
                            fontSize: 11, fontWeight: 500, lineHeight: '18px',
                            color: isCorrectAnswer ? '#15803d' : '#c2410c',
                            background: isCorrectAnswer ? 'rgba(34,197,94,0.12)' : 'rgba(249,115,22,0.12)',
                            padding: '0 8px', borderRadius: 99, whiteSpace: 'nowrap',
                        }}>
                            {isCorrectAnswer ? t('correct') : t('incorrect')}
                        </span>
                    )}
                </div>
            )
        })

    // ─── POLL mode ────────────────────────────────────────────────────────────
    const renderPollAnswer = ({
                                  title,
                                  total_votes: voteNumber,
                                  vote_status: answer_vote_status,
                                  voters = [],
                                  id: poll_answer_id,
                                  is_yesno = false,
                                  isQuiz = false
                              }, i) => {
        const percent = getPercent(voteNumber)
        const restNumber = voters.length - 3

        return (
            <div key={i}>
                <div
                    onClick={() => {
                        if (isQuiz) {
                            showConfirmDialog({
                                icon: <PiHandPointing className="text-primary-500 anticon"/>,
                                translate: t,
                                title: `${t("Confirm your answer")}: \n${title}`,
                                message: 'Are you sure you want to select this answer? Once confirmed, it cannot be changed.',
                                // Override style cho mobile
                                width: '90vw',
                                style: {maxWidth: 360},
                                okButtonProps: {
                                    type: 'text',
                                    block: true,
                                    className: 'rounded-lg no-shadow no-text-shadow no-border font-medium text-red-600',
                                },
                                cancelButtonProps: {
                                    color: 'primary',
                                    variant: 'solid',
                                    block: true,
                                    className: 'rounded-lg no-shadow no-text-shadow no-border',
                                },
                                onOk: () => {
                                    handleVote(poll_answer_id, answer_vote_status)
                                },
                            })
                        } else {
                            handleVote(poll_answer_id, answer_vote_status)
                        }

                    }}
                    data-effect="ripple"
                    style={{
                        borderRadius: 8,
                        border: answer_vote_status
                            ? '1px solid var(--color-primary)'
                            : '1px solid var(--border-color-base)',
                        background: answer_vote_status
                            ? 'var(--color-primary-50)'
                            : 'var(--background)',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        position: 'relative',
                        minHeight: 40,
                        // transition: 'border-color 0.2s, background 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '9px 12px',
                        gap: 8,
                    }} className="hover:scale-99 hover:shadow transition-all duration-300 1111-1111">

                    {/* Progress bar */}
                    <div style={{
                        position: 'absolute', left: 0, top: 0,
                        height: '100%', width: `${percent}%`,
                        background: answer_vote_status
                            ? 'var(--color-primary-100)'
                            : 'var(--background)',
                        transition: 'width 0.4s cubic-bezier(.4,0,.2,1)',
                        zIndex: 0,
                    }} className="2222-2222"/>

                    {/* Radio / Checkbox */}
                    <div style={{zIndex: 1, flexShrink: 0, lineHeight: 1}}>
                        {_.get(poll, 'vote_on_maximum', 1) === 1 || is_yesno ? (
                            <Radio checked={answer_vote_status}>
                                <span style={{
                                    fontSize: 13, lineHeight: 1.5,
                                    fontWeight: answer_vote_status ? 500 : 400,
                                    color: 'var(--text-color)',
                                }}>
                                    {is_yesno ? t(title) : title}
                                </span>
                            </Radio>
                        ) : (
                            <Checkbox checked={answer_vote_status}>
                                <span style={{
                                    fontSize: 13, lineHeight: 1.5,
                                    fontWeight: answer_vote_status ? 500 : 400,
                                    color: 'var(--text-color)',
                                }}>
                                    {title}
                                </span>
                            </Checkbox>
                        )}
                    </div>

                    {/* Voters + Percent */}
                    {percent > 0 && (!isQuiz || (isQuiz && hasAnswered)) && (
                        <div style={{
                            zIndex: 1,
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            flexShrink: 0
                        }}>
                            <VoterAvatars voters={voters} restNumber={restNumber} id={id}
                                          poll_answer_id={poll_answer_id}/>
                            <span className="text-xs" style={{
                                fontWeight: 500, fontStyle: 'italic',
                                color: answer_vote_status ? 'var(--color-primary)' : 'var(--text-color-300)',
                            }}>
                                {percent}%
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    // PollEmbed không tự thêm padding — parent card chịu trách nhiệm
    return (
        <div className="px-4 py-3 background rounded-lg">
            {/* Câu hỏi */}
            <div style={{marginBottom: 12}}>
                <Link className="text-base"
                      to={getLinkToDetail(poll)}
                      style={{
                          fontWeight: 500, lineHeight: 1.55,
                          color: 'var(--text-color)',
                          textDecoration: 'none',
                          display: 'block',
                      }}>
                    {question}
                </Link>
            </div>

            {/* Danh sách đáp án */}
            <div className="flex flex-col gap-3">
                {!!is_yesno_question &&
                poll_yesno_answers.map((answer, i) => {
                    if (isQuiz && hasAnswered) return renderQuizAnswers([answer])[0]
                    return renderPollAnswer({...answer, is_yesno: true, isQuiz}, i)
                })
                }
                {!!!is_yesno_question &&
                (isQuiz && hasAnswered
                        ? renderQuizAnswers(poll_answers)
                        : poll_answers.map((answer, i) => renderPollAnswer({...answer, isQuiz}, i))
                )
                }
            </div>

            {/* Quiz status: chưa vote → gợi ý | đã vote → kết quả */}
            {isQuiz && (() => {
                if (!hasAnswered) {
                    return (
                        <div className="text-sm"
                             style={{marginTop: 10, fontStyle: 'italic', color: 'var(--text-color-400)'}}>
                            {t("Which answer do you choose? Leave your answer below!")}
                        </div>
                    )
                }
                const allAnswers = !!is_yesno_question ? poll_yesno_answers : poll_answers
                const myAnswer = allAnswers.find(a => Boolean(a.vote_status))
                const isCorrect = myAnswer ? Boolean(myAnswer.is_correct) : false
                return (
                    <div style={{
                        marginTop: 12, padding: '10px 14px', borderRadius: 8,
                        display: 'flex', alignItems: 'center', gap: 10,
                        background: isCorrect ? 'rgba(34,197,94,0.08)' : 'rgba(249,115,22,0.08)',
                        border: `1px solid ${isCorrect ? 'rgba(34,197,94,0.30)' : 'rgba(249,115,22,0.30)'}`,
                    }}>
                        <div style={{
                            width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: isCorrect ? '#22c55e' : '#f97316',
                        }}>
                            {isCorrect
                                ? <RiCheckLine size={15} color="#fff"/>
                                : <RiCloseLine size={15} color="#fff"/>
                            }
                        </div>
                        <div className="text-sm" style={{flex: 1, minWidth: 0}}>
                            <div className="text-sm"
                                 style={{fontWeight: 500, color: isCorrect ? '#15803d' : '#c2410c'}}>
                                {isCorrect ? t('you answered correctly') : t('you answered incorrectly')}
                            </div>
                            {myAnswer && (
                                <div className="text-sm" style={{color: 'var(--text-color-300)', marginTop: 2}}>
                                    {t('your answer')}: <span
                                    style={{fontWeight: 500, color: 'var(--text-color-100)'}}>{myAnswer.title}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )
            })()}

            {/* Add new answer */}
            {!!!is_yesno_question && (
                <PermissionContext.Consumer>
                    {({add_new_answer}) =>
                        add_new_answer && (
                            <Toggle>
                                {(isToggle, toggle) => (
                                    <div style={{marginTop: 10}}>
                                        <div style={{
                                            display: 'flex', justifyContent: 'flex-end',
                                            alignItems: 'center', gap: 4, marginBottom: 4,
                                            color: 'var(--text-color-400)',
                                        }}>
                                            <RiAddCircleLine size={13}/>
                                            <span className="text-sm"
                                                  onClick={toggle}
                                                  style={{fontStyle: 'italic', fontWeight: 500, cursor: 'pointer'}}>
                                                {`${t('add answer')} ...`}
                                            </span>
                                        </div>
                                        {renderIf(isToggle,
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <div style={{flex: 1}}>{input}</div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Toggle>
                        )
                    }
                </PermissionContext.Consumer>
            )}
        </div>
    )
}